import React, { useEffect, useState } from 'react';
import moment from 'moment';

export const Calendario = ({
    name = "fecha",
    id = "fecha1",
    value = "",
    disabled = 'false',
    placeholder = "Fecha",
    className = "fecha1",
    updateValue,
    handleInputChange
}) => {

    const [valuedate, setvaluedate] = useState(value)

    useEffect(() => {
        const $ = window.jQuery;
        $("#" + id).daterangepicker({
            autoClose: true,
            singleDatePicker: true,
            showDropdowns: true,
            minYear: 1901,
            dateFormat: 'DD-MM-YYYY',
            startDate: value,
            //maxYear: parseInt(moment().year()),
            locale: {
                "format": "DD-MM-YYYY",
                "separator": "-",
                "applyLabel": "Aplicar",
                "cancelLabel": "Cancelar",
                "fromLabel": "Desde",
                "toLabel": "Hasta",
                "customRangeLabel": "Custom",
                "daysOfWeek": [
                    "Do",
                    "Lu",
                    "Ma",
                    "Mi",
                    "Ju",
                    "Vi",
                    "Sá"
                ],
                "monthNames": [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre"
                ],
                "firstDay": 1
            }
        },
            function (start, end) {
                //updateValue(name, start.format('DD-MM-YYYY'));
                //handleInputChange({ target: { name: name, value: start.format('DD-MM-YYYY') } });
                setvaluedate(start.format('DD-MM-YYYY'));
                //console.log(start.format('DD-MM-YYYY'));
                changeDatePicker(start.format('DD-MM-YYYY'));
            });

    }, [])

    const changeDatePicker = (nuevafecha) => {
        //console.log("changeDatePicker");
        //console.log("name " + name);
        //console.log("valdate " + nuevafecha);
        updateValue(name, nuevafecha);
    };

    return (
        <input
            name={name}
            className={className}
            placeholder={placeholder}
            id={id}
            disabled={disabled === 'false' ? '' : 'disabled'}
            value={valuedate}
            onChange={changeDatePicker}
        />
    )
}
